import gql from 'graphql-tag';

const deficiencyQueries = {
    getDeficiencies: gql`
        query Test($building_id: Int) {
            findProjectsByBuilding(count:9999, building_id: $building_id) {
                data {
                    id
                    project {
                            id
                            name
                            number_internal
                            reminder
                            status {
                                name
                                prio
                                color
                                closed
                            }
                        }
                }
            }
        }
    `,
}

export default deficiencyQueries;
